import React from "react";
import { Link } from "react-router-dom";
import "./error.css";
import { useSelector } from "react-redux";

const E500 = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  return (
    <div className="error-container">
      <div className="error-content">
        <div className="error-code">500</div>
        <div className="error-message">Internal server error</div>
        <Link to={isAuthenticated ? "/home" : "/"}>BACK TO HOME</Link>
      </div>
    </div>
  );
};

export default E500;
